import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import ProductCard from "CommonComponents/ProductCard/ProductCard.jsx";

export default function FeaturedProducts({
  products,
  loading,
  headerRefresh,
  setHeaderRefresh,
}) {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography
        variant="h4"
        align="center"
        sx={{ fontWeight: "bold", mb: 1 }}
      >
        Featured Products
      </Typography>
      <Box
        sx={{
          width: "80px",
          height: "2px",
          backgroundColor: "primary.main",
          mx: "auto",
          mb: 2,
        }}
      />
      <Grid container spacing={0.5}>
        {loading
          ? // Skeleton placeholders while loading
            Array.from(new Array(8)).map((_, index) => (
              <Grid item xs={6} sm={4} md={3} lg={2.4} key={index}>
                <Box
                  sx={{
                    width: "100%",
                    borderRadius: "8px",
                    overflow: "hidden",
                    p: 1,
                  }}
                >
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={200}
                    animation="wave"
                  />
                  <Box sx={{ pt: 1 }}>
                    <Skeleton animation="wave" height={32} width="70%" />
                    <Skeleton animation="wave" height={20} width="50%" />
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 1,
                      }}
                    >
                      <Skeleton animation="wave" height={28} width="40%" />
                      <Skeleton animation="wave" height={28} width="20%" />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))
          : products &&
            products.length > 0 &&
            products.map((product) => (
              <Grid item xs={6} sm={4} md={3} lg={2.4} key={product.Product_Id}>
                <Box sx={{ p: { xs: 0.5, md: 1 } }}>
                  <ProductCard
                    product={product}
                    headerRefresh={headerRefresh}
                    setHeaderRefresh={setHeaderRefresh}
                  />
                </Box>
              </Grid>
            ))}
      </Grid>
    </Container>
  );
}
